
import React from 'react';
import Particles from 'react-tsparticles';
import {loadSlim} from 'tsparticles-slim';

function LoftyAnimatedParticleBackground ({
  particleCount, particleColor, shapeType,
  particleSize, lineLinkDistance,
  id, className, children,
}) {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };
  const particlesOptions = {
    fullScreen: {
      enable: false,
    },
    particles: {
      number: {
        value: parseInt(particleCount) || 80,
        density: {enable: true, value_area: 800},
      },
      color: {
        value: particleColor || '#000000',
      },
      shape: {
        type: shapeType || 'circle',
        stroke: {width: 0, color: '#000000'},
      },
      opacity: {
        value: 0.5,
        random: false,
        anim: {enable: false},
      },
      size: {
        value: parseInt(particleSize) || 3,
        random: true,
        anim: {enable: false},
      },
      line_linked: {
        enable: true,
        distance: parseInt(lineLinkDistance) || 150,
        color: particleColor || '#000000',
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 6,
        direction: 'none',
        out_mode: 'out',
      },
    },
    interactivity: {
      detect_on: 'canvas',
      events: {
        onhover: {enable: true, mode: 'repulse'},
        onclick: {enable: true, mode: 'push'},
      },
      modes: {
        repulse: {distance: 100},
        push: {particles_nb: 4},
      },
    },
    retina_detect: true,
  };
  return (
    <div className={className} id={id} style={{position: 'relative'}}>
      <Particles
        init={particlesInit}
        options={particlesOptions}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      />
      {children}
    </div>
  );
}

export default LoftyAnimatedParticleBackground;
  
  